module.exports = __webpack_public_path__ + "static/media/vida-connect-logo.243d1c48.svg";